export enum ButtonType {
    DEFAULT = 'default',
    DELETE = 'delete',
    SAVE = 'save',
}